/** @jsxImportSource @emotion/react */
import { DownOutlined, SyncOutlined } from "@ant-design/icons";
import { Image, Tooltip } from "antd";
import IconRMCurrency from "assets/images/dollar.png";
import PopupCustom, { RefTypePopup } from "components/ui/Header/PopupCustom";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import React, { useRef } from "react";
import { selectUsername } from "store/auth";
import { selectBalance, selectBalanceLoading } from "store/user";
import { getMemberBalance } from "store/user/user.thunk";

import { WalletDropdownStyle } from "./index.style";

function WalletDropdown() {
  const dispatch = useAppDispatch();
  const popupRef = useRef<RefTypePopup>(null);

  const username = useAppSelector(selectUsername);
  const memberBalance = useAppSelector(selectBalance);
  const isLoading = useAppSelector(selectBalanceLoading);

  const dataCurrency = [
    {
      name: "BDT",
      icon: IconRMCurrency,
      amount: memberBalance?.total
    }
  ];

  return (
    <>
      <PopupCustom
        ref={popupRef}
        top={"60px"}
        buttonContent={
          <div css={WalletDropdownStyle.container}>
            <div
              onClick={() => {
                popupRef.current?.onToggle();
              }}
              css={WalletDropdownStyle.value}
            >
              <Image src={IconRMCurrency} preview={false} />
              <Tooltip
                title={
                  parseFloat(memberBalance?.total) > 10000
                    ? memberBalance?.total
                    : null
                }
              >
                <span className="balance-text">{memberBalance?.total}</span>
              </Tooltip>
              <DownOutlined className="iconProps" />
            </div>
            <div
              css={[
                WalletDropdownStyle.refresh,
                isLoading && WalletDropdownStyle.loading
              ]}
            >
              <span onClick={() => dispatch(getMemberBalance({ username }))}>
                <SyncOutlined />
              </span>
            </div>
          </div>
        }
        popupContent={
          <div css={WalletDropdownStyle.contentPopup}>
            <h3>Switch wallet</h3>
            <div className="list-currency">
              {dataCurrency.map((item, index) => {
                return (
                  <div
                    onClick={() => popupRef.current?.onToggle()}
                    key={`item-currency-${index}`}
                    className="item-currency"
                  >
                    <Image
                      src={item.icon}
                      height={24}
                      width={24}
                      preview={false}
                    />
                    <span className="name">{item.name}</span>
                    <Tooltip title={item.amount}>
                      <span className="amount">{item.amount}</span>
                    </Tooltip>
                  </div>
                );
              })}
            </div>
          </div>
        }
      />
    </>
  );
}

export default WalletDropdown;
